module.exports = __webpack_public_path__ + "img/lazysloth.e70baaba.png";